export default __webpack_public_path__ + "static/media/9.d18fb9aa.jpg";